import React from 'react';

/** Thin custom arrow used inside buttons and links. */
export default function Arrow({
  className = '',
  direction = 'right',
}: {
  className?: string;
  direction?: 'right' | 'down';
}) {
  return (
    <svg
      className={`btn-arrow ${className}`}
      width="14"
      height="8"
      viewBox="0 0 18 10"
      fill="none"
      aria-hidden="true"
      style={direction === 'down' ? { transform: 'rotate(90deg)' } : undefined}
    >
      <path d="M0 5h16.5M12.5 1l4 4-4 4" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  );
}
